import { NUMBER_FULL_VALIDATE_REGEX, NUMBER_VALIDATE_REGEX } from '@/configs/constants';
import * as yup from 'yup';

declare module 'yup' {
    interface StringSchema {
    /**
     * Test để cho phép chuỗi rỗng hoặc chỉ chứa chữ số.
     * @param message Thông báo lỗi nếu validation thất bại.
     */
        checkInputOnlyContainDigitsOrEmpty(message: string): StringSchema,

        checkInputOnlyPositiveDigitsOrEmpty(message: string): StringSchema
    }
}

yup.addMethod(yup.string, 'checkInputOnlyContainDigitsOrEmpty', function (message) {
    return this.test('checkInputOnlyContainDigitsOrEmpty', message, function (str) {
        return str === '' || str === undefined || str === null || NUMBER_FULL_VALIDATE_REGEX.test(str);
    });
});

yup.addMethod(yup.string, 'checkInputOnlyPositiveDigitsOrEmpty', function (message) {
    return this.test('checkInputOnlyPositiveDigitsOrEmpty', message, function (str) {
        return str === '' || str === undefined || str === null || NUMBER_VALIDATE_REGEX.test(str);
    });
});

export default yup;
